<script lang="ts">
  import { onMount } from 'svelte'
  import { ChevronLeft, ChevronRight } from 'lucide-svelte'
  import { twMerge } from 'tailwind-merge'

  let classes = ''
  export { classes as class }
  export let images: string[]
  export let duration: number
  export let showControls = true
  export let showDots = true

  let index = 0
  function next() {
    index = (index + 1) % images.length
  }

  function previous() {
    if (index > 0) {
      index = (index - 1) % images.length
    }
  }

  if(images.length === 1) {
    showControls = false
    showDots = false
  }

  onMount(() => {
    const interval = setInterval(next, duration)

    return () => clearInterval(interval)
  })
</script>

<div class={twMerge('flex w-full relative max-h-full overflow-x-hidden', classes)}>
  {#each images as src, idx}
    <img
      {src}
      alt={`Gallery image ${index}`}
      class={twMerge('hidden', idx === index ? 'flex current' : '', 'object-bottom lg:h-[540px]')}
    />
  {/each}

  {#if showDots}
    <div class="dots">
      {#each images as _, idx}
        <span class={twMerge('bg-cs-dark-gray rounded-full h-4 w-4', index === idx ? 'bg-cs-light-gray' : '')} />
      {/each}
    </div>
  {/if}

  {#if showControls}
    <div class="controls">
      <button on:click={previous}><ChevronLeft /></button>
      <button on:click={next}><ChevronRight /></button>
    </div>
  {/if}
</div>

<style lang="postcss">
  img {
    flex: 0 0 100%;
    width: 100%;
    object-fit: cover;
  }

  .controls {
    @apply absolute flex flex-row w-full h-full justify-between items-center text-white p-2;
  }

  .dots {
    @apply absolute flex flex-row w-full h-full justify-center gap-2 items-end text-white p-2;
  }

  .controls > button {
    @apply h-auto w-fit rounded-full bg-cs-light-gray p-2;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  .current {
    animation: fadeIn 2s;
  }
</style>
